import React from 'react'
import {useTranslation} from "react-i18next"
import {useSelector} from "react-redux"
import Urolift_EN from "./Urolift_EN"
import Urolift_RU from "./Urolift_RU"

const Urolift = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)

    switch (language) {
        case 'EN':
            return (
                <Urolift_EN/>
            )
        case 'RU':
            return (
                <Urolift_RU/>
            )
        case 'BG':
            return (
                <Urolift_EN/>
            )
        default:
            return (
                <Urolift_EN/>
            )
    }
}

export default Urolift


// WEBPACK FOOTER //
// ./src/Components/Urolift/Urolift.js